export default "__VITE_ASSET__quQzpGAg__"